import { useEffect, useRef } from 'react'

export function useEmaSmaSync({ movingAverages, activeRegistry, setRegistry, setConfig, snapshotMode = false, addMovingAverage }) {
  const prevMovingAveragesRef = useRef(movingAverages)
  const prevActiveRegistryRef = useRef(activeRegistry)
  const emaSmaEffectRunCountRef = useRef(0)
  const emaSmaWriteCountRef = useRef(0)
  const firstRunRef = useRef(true)

  useEffect(() => {
    emaSmaEffectRunCountRef.current += 1
    if (snapshotMode) return
    if (firstRunRef.current) {
      firstRunRef.current = false
      prevMovingAveragesRef.current = movingAverages
      prevActiveRegistryRef.current = activeRegistry
      return
    }
    const prevMas = prevMovingAveragesRef.current
    const prevReg = prevActiveRegistryRef.current
    prevMovingAveragesRef.current = movingAverages
    prevActiveRegistryRef.current = activeRegistry

    const hasActive = movingAverages.some(ma => ma.active)
    const isRegistryActive = activeRegistry?.['ema_sma_quantum'] === true
    let wrote = false

    if (isRegistryActive && !hasActive && movingAverages.length === 0 && addMovingAverage) {
      console.log('[useEmaSmaSync] run', emaSmaEffectRunCountRef.current, 'addMovingAverage')
      addMovingAverage('ema')
      return
    }

    if (!hasActive && isRegistryActive && movingAverages.length === 0) {
      console.log('[useEmaSmaSync] run', emaSmaEffectRunCountRef.current, 'auto-deactivate')
      setRegistry('ema_sma_quantum', false)
      wrote = true
    }

    const masEqual = prevMas.length === movingAverages.length && prevMas.every((ma, i) => ma.id === movingAverages[i]?.id && ma.active === movingAverages[i]?.active && ma.period === movingAverages[i]?.period && ma.color === movingAverages[i]?.color && ma.type === movingAverages[i]?.type)
    const regEqual = prevReg?.['ema_sma_quantum'] === activeRegistry?.['ema_sma_quantum']
    console.log('[useEmaSmaSync] run', emaSmaEffectRunCountRef.current, { hasActive, isRegistryActive, masEqual, regEqual, prevMasLength: prevMas.length, currentMasLength: movingAverages.length })
    if (!masEqual || !regEqual) {
      console.log('[useEmaSmaSync] run', emaSmaEffectRunCountRef.current, 'setConfig')
      setConfig('ema_sma_quantum', { mas: movingAverages })
      wrote = true
    }
    if (wrote) {
      emaSmaWriteCountRef.current += 1
      console.log('[useEmaSmaSync] write count:', emaSmaWriteCountRef.current)
    }
    if (typeof window !== 'undefined') {
      window.__EMA_SMA_DEBUG__ = {
        effectRuns: emaSmaEffectRunCountRef.current,
        writes: emaSmaWriteCountRef.current,
        hasActive,
        isRegistryActive,
        masEqual,
        regEqual,
      }
    }
  }, [movingAverages, activeRegistry, snapshotMode, setRegistry, setConfig, addMovingAverage])

  return {
    emaSmaEffectRunCountRef,
    emaSmaWriteCountRef,
  }
}
